/**
 * Centralized feature flags
 * Checks environment variables for feature toggles
 */
export const FLAGS = {
  DEEPSEARCH_ENABLED: import.meta.env.VITE_DEEPSEARCH_ENABLED === 'true',
  SWIRLSPACE_ENABLED: import.meta.env.VITE_SWIRLSPACE_ENABLED === 'true',
  SELF_DASHBOARD_ENABLED: import.meta.env.VITE_SELF_DASHBOARD_ENABLED === 'true',
  SMART_SWIRLS_ENABLED: import.meta.env.VITE_SMART_SWIRLS_ENABLED === 'true',
  MOODSYNC_ENABLED: import.meta.env.VITE_MOODSYNC_ENABLED === 'true',
  EMOTIONAL_RESONANCE_ENABLED: import.meta.env.VITE_EMOTIONAL_RESONANCE_ENABLED === 'true',
  REFLECTION_LOOP_ENABLED: import.meta.env.VITE_REFLECTION_LOOP_ENABLED === 'true',
  CLASSIC_SIDEBAR_ENABLED: import.meta.env.VITE_CLASSIC_SIDEBAR_ENABLED === 'true',
  INTEREST_MAP_ENABLED: import.meta.env.VITE_INTEREST_MAP_ENABLED === 'true',
  DISCOVERY_MODE_ENABLED: import.meta.env.VITE_DISCOVERY_MODE_ENABLED === 'true',
  DASHBOARD_DATA_HUB_ENABLED: import.meta.env.VITE_DASHBOARD_DATA_HUB_ENABLED === 'true',
  MOOD_PATHING_ENABLED: import.meta.env.VITE_MOOD_PATHING_ENABLED === 'true',
  MOOD_FEEDBACK_ENABLED: import.meta.env.VITE_MOOD_FEEDBACK_ENABLED === 'true',
  ENGAGEMENT_DASHBOARD_ENABLED: import.meta.env.VITE_ENGAGEMENT_DASHBOARD_ENABLED === 'true',
  BEHAVIORAL_LEARNING_ENABLED: import.meta.env.VITE_BEHAVIORAL_LEARNING_ENABLED === 'true',
  BEHAVIOR_RECS_ENABLED: import.meta.env.VITE_BEHAVIOR_RECS_ENABLED === 'true',
  COLD_START_ENABLED: import.meta.env.VITE_COLD_START_ENABLED === 'true',
  COHORT_SEEDING_ENABLED: import.meta.env.VITE_COHORT_SEEDING_ENABLED === 'true',
  WELCOME_FLOW_ENABLED: import.meta.env.VITE_WELCOME_FLOW_ENABLED === 'true',
  CURIOSITY_MEMORY_ENABLED: import.meta.env.VITE_CURIOSITY_MEMORY_ENABLED === 'true',
  // Stage 6: Personalization & Discovery
  FEATURE_DISCOVER_PAGE: import.meta.env.VITE_FEATURE_DISCOVER_PAGE !== 'false', // Default true
  FEATURE_SECTION_TRENDING: import.meta.env.VITE_FEATURE_SECTION_TRENDING === 'true', // Default false
  FEATURE_MOODSYNC: import.meta.env.VITE_FEATURE_MOODSYNC !== 'false', // Default true
};

/**
 * API Keys Configuration
 * Phase 9.6: Centralized API key management for recommendation services
 */
export const API_KEYS = {
  GOOGLE_BOOKS: import.meta.env.VITE_GOOGLE_BOOKS_API_KEY || null,
  YOUTUBE: import.meta.env.VITE_YOUTUBE_API_KEY || null,
  NEWSAPI: import.meta.env.VITE_NEWSAPI_KEY || import.meta.env.VITE_NEWS_API_KEY || null, // Support both naming conventions
  TMDB: import.meta.env.VITE_TMDB_API_KEY || null,
  TMDB_BEARER: import.meta.env.VITE_TMDB_BEARER || null,
  PODCHASER: import.meta.env.VITE_PODCHASER_API_KEY || import.meta.env.VITE_PODCHASER_API || null, // Support both
  PODCHASER_CLIENT_TOKEN: import.meta.env.VITE_PODCHASER_CLIENT_TOKEN || null,
  LISTENNOTES: import.meta.env.VITE_LISTENNOTES_API_KEY || null,
  OPENLIBRARY_FALLBACK: import.meta.env.VITE_OPENLIBRARY_FALLBACK !== 'false', // Default true
};

/**
 * Check which APIs are active and log at startup
 */
export function logActiveAPIs() {
  const active = [];
  const inactive = [];

  if (API_KEYS.GOOGLE_BOOKS || API_KEYS.OPENLIBRARY_FALLBACK) {
    active.push('Books');
  } else {
    inactive.push('Books');
  }

  if (API_KEYS.YOUTUBE) {
    active.push('YouTube');
  } else {
    inactive.push('YouTube');
  }

  if (API_KEYS.NEWSAPI) {
    active.push('News');
  } else {
    inactive.push('News');
  }

  if (API_KEYS.TMDB || API_KEYS.TMDB_BEARER) {
    active.push('Movies');
  } else {
    inactive.push('Movies');
  }

  if (API_KEYS.PODCHASER || API_KEYS.PODCHASER_CLIENT_TOKEN || API_KEYS.LISTENNOTES) {
    active.push('Podcasts');
  } else {
    inactive.push('Podcasts');
  }

  const activeList = active.map(a => `${a} ✓`).join(' ');
  const inactiveList = inactive.length > 0 ? ` (${inactive.join(', ')} missing keys)` : '';

  console.log(`📡 Active APIs: ${activeList}${inactiveList}`);

  return {
    active: active.length,
    total: 5,
    activeList,
    inactiveList
  };
}

